var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSomeRemote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81838 5.68637C1.81838 5.13585 2.15156 4.64615 2.6476 4.4676L9.60197 1.96439C9.85995 1.87153 10.14 1.87153 10.398 1.96439L17.3524 4.4676C17.8484 4.64615 18.1816 5.13585 18.1816 5.68637V17.7116C18.1816 18.4232 17.6322 19 16.9544 19H3.04562C2.36783 19 1.81838 18.4232 1.81838 17.7116V5.68637Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6809 8.53297C13.707 7.46347 12.8316 6.55713 11.7291 6.54551C10.991 6.53771 10.3453 6.92326 9.99978 7.49924C9.65425 6.92326 9.00861 6.53765 8.27047 6.54551C7.16797 6.55713 6.29261 7.46347 6.31862 8.53297C6.37682 10.9228 9.32268 13.0015 9.90162 13.3873C9.96081 13.4268 10.0388 13.4268 10.098 13.3873C10.6769 13.0015 13.6227 10.9228 13.6809 8.53297Z",
    fill: "#EEF6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52981 1.07245C9.83652 0.97585 10.1635 0.97585 10.4702 1.07245L18.4167 3.57524C18.8495 3.71155 19.0951 4.1904 18.9653 4.64477C18.8354 5.09915 18.3793 5.35699 17.9465 5.22067L10 2.71789L2.05347 5.22067C1.62067 5.35699 1.16456 5.09915 1.03472 4.64477C0.90488 4.1904 1.15048 3.71155 1.58328 3.57524L9.52981 1.07245Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeRemote);
export default __webpack_public_path__ + "static/media/someRemote.90bfb92d.svg";
export { ForwardRef as ReactComponent };